import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 svg-icon-success me-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "22",
    viewBox: "0 0 22 22"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z",
      fill: "#00A300"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "permanent",
      d: "M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z",
      fill: "white"
    })
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 svg-icon-danger me-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    class: "bi bi-patch-exclamation-fill",
    viewBox: "0 0 18 18"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2",
      fill: "white"
    })
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 svg-icon-warning me-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    class: "bi bi-stopwatch-fill",
    viewBox: "0 0 18 18"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6.5 0a.5.5 0 0 0 0 1H7v1.07A7.001 7.001 0 0 0 8 16a7 7 0 0 0 5.29-11.584l.013-.012.354-.354.353.354a.5.5 0 1 0 .707-.707l-1.414-1.415a.5.5 0 1 0-.707.707l.354.354-.354.354-.012.012A6.97 6.97 0 0 0 9 2.071V1h.5a.5.5 0 0 0 0-1zm2 5.6V9a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1 0-1h3V5.6a.5.5 0 1 1 1 0",
      fill: "white"
    })
  ])
], -1)
const _hoisted_7 = { class: "form-content" }
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_CountDown = _resolveComponent("CountDown")!
  const _component_Form1 = _resolveComponent("Form1")!
  const _component_Form2 = _resolveComponent("Form2")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "General Entry Form",
    modelValue: _ctx.dialogForm,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogForm) = $event)),
    "close-on-click-modal": false,
    class: "bg-light rounded",
    top: "2vh",
    width: "70%",
    height: _ctx.altura <= 500 ? '500px' : _ctx.altura + 'px',
    onOpen: _ctx.onOpened,
    onClosed: _ctx.onClosed
  }, _createSlots({
    header: _withCtx(({ titleId }) => [
      _createElementVNode("h3", {
        id: titleId,
        class: "card-title align-items-start flex-column"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: "card-label font-weight-bolder text-dark me-2",
            textContent: _toDisplayString(_ctx.itemForm?.form_name)
          }, null, 8, _hoisted_3),
          (_ctx.itemForm?.status?.iddetails == 1)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                class: "box-item",
                effect: "dark",
                content: _ctx.itemForm?.status?.name,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["content"]))
            : _createCommentVNode("", true),
          (_ctx.itemForm?.status?.iddetails == 2)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 1,
                class: "box-item",
                effect: "dark",
                content: _ctx.itemForm?.status?.name,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["content"]))
            : _createCommentVNode("", true),
          (_ctx.itemForm?.status?.iddetails == 3)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 2,
                class: "box-item",
                effect: "dark",
                content: _ctx.itemForm?.status?.name,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["content"]))
            : _createCommentVNode("", true),
          (_ctx.itemForm)
            ? (_openBlock(), _createBlock(_component_CountDown, {
                key: 3,
                fechafin: _ctx.itemForm.end_date,
                "class-name": "text-center border rounded bg-primary h6 fw-normal mb-0 text-white",
                "class-text": "mb-0 fw-bolder",
                subtitle: "font-size:10px;",
                onChangeStatus: _ctx.changeStatus
              }, null, 8, ["fechafin", "onChangeStatus"]))
            : _createCommentVNode("", true)
        ])
      ], 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createVNode(_component_el_scrollbar, {
          ref: "scrollbarRef",
          height: `${_ctx.altura - 300}px`
        }, {
          default: _withCtx(() => [
            (_ctx.idForm == 1)
              ? (_openBlock(), _createBlock(_component_Form1, {
                  key: 0,
                  ref: "childComponentRef",
                  idevent: _ctx.idevent,
                  onFormLoaded: _ctx.onFormLoaded
                }, null, 8, ["idevent", "onFormLoaded"]))
              : _createCommentVNode("", true),
            (_ctx.idForm == 2)
              ? (_openBlock(), _createBlock(_component_Form2, {
                  key: 1,
                  ref: "childComponentRef",
                  idevent: _ctx.idevent,
                  onFormLoaded: _ctx.onFormLoaded
                }, null, 8, ["idevent", "onFormLoaded"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["height"])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 2
  }, [
    (_ctx.childComponentRef)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              (!_ctx.formExpired)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.childComponentRef?.formQ.mstatus == 0)
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveAsDraf()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t("save2")), 1)
                          ]),
                          _: 1
                        })), [
                          [_directive_loading, !_ctx.isFormLoaded]
                        ])
                      : _createCommentVNode("", true),
                    (_ctx.childComponentRef?.formQ.mstatus == 0)
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          disabled: !_ctx.isFormLoaded,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveAndSend()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t("save1")), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])), [
                          [_directive_loading, !_ctx.isFormLoaded]
                        ])
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_button, {
                      color: "#E71D2E",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogForm = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString((_ctx.childComponentRef?.formQ.mstatus == 0) ? _ctx.t("cancel") : _ctx.t("close")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    color: "#E71D2E",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogForm = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("close")), 1)
                    ]),
                    _: 1
                  }))
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "height", "onOpen", "onClosed"]))
}